import { useContext } from 'react';
import { IPromotion } from 'common/promotion';
import { IItinerary } from 'common/types';
import { InternationalContext } from 'contexts/international';
import { TripType } from 'contexts/searchParams';
import { IInternationalContextResult, SelectTypeKeys } from '../types';
import ConcurrentList from './list';

interface IProps {
  fareType: string;
  flightResult: IInternationalContextResult;
  itinerary: IItinerary[];
  promotions: IPromotion[];
  samePriceOrgSch?: string;
  tripType: TripType;
  selectFlights: (
    sch: string,
    fareType: string,
    airline: string,
    labels: string[],
  ) => void;
  setMinFare: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const ConcurrentListContainer = ({
  fareType,
  flightResult,
  itinerary,
  promotions,
  tripType,
  selectFlights,
  setMinFare,
}: IProps) => {
  const { sortSchs } = useContext(InternationalContext);
  const { schs } = flightResult;
  const sortedSchs = sortSchs(schs, SelectTypeKeys.concurrent, flightResult);
  return (
    <ConcurrentList
      fareType={fareType}
      flightResult={flightResult}
      itinerary={itinerary}
      promotions={promotions}
      schs={sortedSchs}
      tripType={tripType}
      selectFlights={selectFlights}
      setMinFare={setMinFare}
    />
  );
};

export default ConcurrentListContainer;
